import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      <h1>YulDev-Blog</h1>
      <p>2023 KimJiyul &copy; All Rights Reserved.</p>
    </footer>
  );
}
